var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnHide24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2661 10.715C22.7771 11.4961 22.7771 12.504 22.2661 13.2852C21.2909 14.7762 19.9991 16.0421 18.4759 16.9889C16.532 18.1972 14.2888 18.8376 12 18.8376C9.71116 18.8376 7.46797 18.1972 5.52406 16.9889C4.00089 16.0421 2.70908 14.7762 1.73387 13.2852C1.22294 12.504 1.22294 11.4961 1.73387 10.715C2.70908 9.22396 4.00089 7.95806 5.52406 7.01127C7.46797 5.80296 9.71116 5.1626 12 5.1626C14.2888 5.1626 16.532 5.80296 18.4759 7.01127C19.9991 7.95806 21.2909 9.22396 22.2661 10.715Z",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 15.3C13.8218 15.3 15.2992 13.8225 15.2992 12C15.2992 10.1774 13.8218 8.69995 11.9992 8.69995C10.1767 8.69995 8.69922 10.1774 8.69922 12C8.69922 13.8225 10.1767 15.3 11.9992 15.3Z",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnHide24Px);
export default __webpack_public_path__ + "static/media/UnHide_24px.b83081f51eca2360a734eec69a122330.svg";
export { ForwardRef as ReactComponent };